export default __webpack_public_path__ + "static/media/GMC.a3c08f66.png";